import React from 'react';
import styled from 'styled-components';
    
const InputText = styled.input`
    height: 25px;
    padding: 5px 10px;
    font-size: 11px;
`;

const Button = styled.button`
    height: 25px;
    padding: 0px 10px;
    font-size: 11px;
`;

export default class InputSearch extends React.Component{
    constructor(props){ 
        super(props);
        this.handleKeyUp = this.handleKeyUp.bind(this);
    }

    handleKeyUp(e){
        if(e.keyCode===13){
            this.props.func_BuscarValor();
        }
    }

    render(){
        const height = this.props.height? `${this.props.height.toString()}px` : '25px';
        return(
            <div className='input-group'>
               <InputText autoComplete='off' type={this.props.tipoInput} name={this.props.nombre} 
                className='form-control' value={this.props.valor}  onChange={this.props.func_CambiarValor}
                placeholder={this.props.placeholder} onFocus={this.props.func_OnFocus} maxLength={this.props.maxLength}
                onKeyUp={this.handleKeyUp} onBlur={this.props.func_Onblur}
               />
               <span className='input-group-btn'>
                  <Button style={{height:height}} className='btn btn-default' type='button' disabled={this.props.disabled || false} onClick={this.props.func_BuscarValor}><i className='fa fa-search' aria-hidden='true'/></Button>
               </span>
            </div>
        )
    }
}    

